import { ERoomType } from '../../../../../packages/JsonQuery';

type TSpecialRoomType = Extract<ERoomType, ERoomType.Studio | ERoomType.FlatFreeLayout>;

const SPECIAL_ROOM_TYPE_NAMES = {
  [ERoomType.Studio]: 'студия',
  [ERoomType.FlatFreeLayout]: 'своб. план.',
};

export const getSpecialRoomTypeNames = (roomTypes: ERoomType[]): string[] => {
  const roomTypesSorted = roomTypes.filter(type => type in SPECIAL_ROOM_TYPE_NAMES).sort() as TSpecialRoomType[];

  return roomTypesSorted.map(type => SPECIAL_ROOM_TYPE_NAMES[type]);
};
